"use client";

import dynamic from "next/dynamic";
import { useState } from "react";
import { Search } from "lucide-react";

const SearchDrawer = dynamic(
  () => import("./SearchDrawer").then((module) => module.SearchDrawer),
  { ssr: false }
);

export function LazySearchDrawer() {
  const [searchRequested, setSearchRequested] = useState(false);

  if (searchRequested) {
    return <SearchDrawer initialOpen />;
  }

  return (
    <button
      type="button"
      className="flex items-center justify-center text-header-foreground transition-colors duration-200 hover:text-brand-nav-accent focus:outline-none"
      aria-label="Search"
      onClick={() => setSearchRequested(true)}
    >
      <Search className="size-6" strokeWidth={2.5} />
    </button>
  );
}
